/* eslint-disable max-len */
import React from "react"
import { CDN } from "../../../../../config"
export default function ContactDetails({ studentDetails }) {

    function splitStringIntoGroups(str, groupSize) {
        const chunks = [];
        for (let i = 0; i < str?.length; i += groupSize) {
            chunks.push(str.substr(i, groupSize));
            if(i===6)
                break
        }
        return chunks.join(" ")+str[9];
       
    }
    return(
        <div class="transition-opacity duration-150 ease-linear data-[te-tab-active]:block px-2.5 mt-5" id="tabs-institutionuserList" role="tabpanel" aria-labelledby="tabs-institutionuserList-tab">
            <div class="w-[800px] mx-auto">
                <div class="w-full border border-[#e7e7e7] rounded p-4 mb-4">
                    <div class="flex pb-4 border-b border-[#e7e7e7]">
                        <div class="w-1/2 pr-4">
                            <p class="text-f7 font-semibold text-[#031624] w-full pb-[18px]">Student Contact Details</p>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[65%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Address Line 1</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.address_line1} </p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[65%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Address Line 2</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.address_line2}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[65%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">PIN Code</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.pin_code}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[65%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Area</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.area}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[65%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">City</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.city}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[65%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">State</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.state}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[65%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Email Address</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.email_address}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1">
                                <div class="w-[65%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Mobile Number</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{splitStringIntoGroups(studentDetails?.mobile_number,3)}</p>
                                </div>
                            </div>
                        </div>
                        <div class="w-1/2 pl-4 border-l border-[#e7e7e7]">
                            <p class="text-f7 font-semibold text-[#031624] w-full pb-[18px]">Emergency Contact Details</p>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[65%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Name</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.emergency_contact?.name!==""?studentDetails?.emergency_contact?.name:"-"}</p>
                                </div>
                            </div>
                            <div class="flex -mx-1 mb-4">
                                <div class="w-[65%]  px-1">
                                    <p class="text-f7 font-normal text-[#031624] w-full">Mobile Number</p>
                                </div>
                                <div class="w-full px-1">
                                    <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.emergency_contact?.mobile_number!==""?splitStringIntoGroups(studentDetails?.emergency_contact?.mobile_number,3):"-"}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {studentDetails.is_father_details && <div class="">
                        <p class="text-f7 font-semibold text-[#031624] w-full pb-2 pt-4">Father Details</p>
                        <div class="w-full border border-[#e7e7e7] rounded p-4">
                            <div class="flex">
                                <div class="w-1/2 pr-4">
                                    <div class="flex items-center mb-4">
                                        <img src={studentDetails?.father_details?.father_image_url !== "" ? `${CDN}${studentDetails?.father_details?.father_image_url}`:"/images/photo_uploaded.svg"} alt="img" class="w-[96px] h-[96px] rounded"/>
                                    </div>
                                    <div class="flex -mx-1 mb-4">
                                        <div class="w-[65%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">First Name</p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.father_details?.first_name}</p>
                                        </div>
                                    </div> 
                                    <div class="flex -mx-1 mb-4">
                                        <div class="w-[65%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">Middle Name</p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.father_details?.middle_name!==""?studentDetails?.father_details?.middle_name:"-"}</p>
                                        </div>
                                    </div>
                                    <div class="flex -mx-1">
                                        <div class="w-[65%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">Last Name</p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.father_details?.last_name!==""?studentDetails?.father_details?.last_name:"-"}</p>
                                        </div>
                                    </div>
                                </div>
                            
                                <div class="w-1/2 pl-4 border-l border-[#e7e7e7] ">
                                    <div class="flex -mx-1 mb-4 mt-[25px]">
                                        <div class="w-[80%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">Email Address</p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.father_details?.email_address!==""?studentDetails?.father_details?.email_address:"-"}</p>
                                        </div>
                                    </div>
                                    <div class="flex -mx-1 mb-4">
                                        <div class="w-[80%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">Mobile Number</p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.father_details?.mobile_number!==""?splitStringIntoGroups(studentDetails?.father_details?.mobile_number,3):"-"}</p>
                                        </div>
                                    </div>
                                    <div class="flex -mx-1 mb-4">
                                        <div class="w-[80%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">PAN</p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.father_details?.pan_number}</p>
                                        </div>
                                    </div>
                                    <div class="flex -mx-1">
                                        <div class="w-[80%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">Aadhaar No.</p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.father_details?.aadhar_number?.number!==""?studentDetails?.father_details?.aadhar_number?.number:"-"}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                    {studentDetails.is_mother_details&& <div class="">
                        <p class="text-f7 font-semibold text-[#031624] w-full pb-2 pt-4">Mother Details</p>
                        <div class="w-full border border-[#e7e7e7] rounded p-4">
                            <div class="flex">
                                <div class="w-1/2 pr-4">
                                    <div class="flex items-center mb-4">
                                        <img src={studentDetails?.mother_details?.mother_image_url !== "" ? `${CDN}${studentDetails?.mother_details?.mother_image_url}`:"/images/photo_uploaded.svg"} alt="img" class="w-[96px] h-[96px] rounded"/>
                                    </div>
                                    <div class="flex -mx-1 mb-4">
                                        <div class="w-[65%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">First Name</p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.mother_details?.first_name}</p>
                                        </div>
                                    </div>
                                    <div class="flex -mx-1 mb-4">
                                        <div class="w-[65%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">Middle Name</p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.mother_details?.middle_name!==""?studentDetails?.mother_details?.middle_name:"-"}</p>
                                        </div>
                                    </div>
                                    <div class="flex -mx-1">
                                        <div class="w-[65%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">Last Name</p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.mother_details?.last_name!==""?studentDetails?.mother_details?.last_name:"-"}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-1/2 pl-4 border-l border-[#e7e7e7] ">
                                    <div class="flex -mx-1 mb-4 mt-[32px]">
                                        <div class="w-[80%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">Email Address</p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.mother_details?.email_address!==""?studentDetails?.mother_details?.email_address:"-"}</p>
                                        </div>
                                    </div>
                                    <div class="flex -mx-1 mb-4">
                                        <div class="w-[80%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">Mobile Number</p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.mother_details?.mobile_number!==""?splitStringIntoGroups(studentDetails?.mother_details?.mobile_number,3):"-"}</p>
                                        </div>
                                    </div>
                                    <div class="flex -mx-1 mb-4">
                                        <div class="w-[80%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">PAN</p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.mother_details?.pan_number}</p>
                                        </div>
                                    </div>
                                    <div class="flex -mx-1">
                                        <div class="w-[80%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">Aadhaar No.</p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">{studentDetails?.mother_details?.aadhar_number?.number!==""?studentDetails?.mother_details?.aadhar_number?.number:"-"}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        </div>
    )
}
